module.exports = __webpack_public_path__ + "img/career.70d79970.jpg";